import React from "react";
import { useNavigate } from "react-router-dom";
import PrivateRoutes from "../AuthRoutes/PrivateRoutes";

export default function Sidebar() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const response = await fetch("/logout", {
        method: "GET",
        credentials: "include", // Includes creditials to send cookie with the session ID
      });
      if (response.status === 200) {
        // PrivateRoutes();
        navigate("/login");
        console.log("Logout Successfully");
      } else {
        console.error("Logout Failed");
      }
    } catch (error) {
      console.error("Error During Logout:", error);
    }
  };

  return (
    <div className=" fixed  max-w-xs w-72 h-screen flex-col justify-between border-e bg-white hidden sm:block ">
      <div className="px-4 py-6">
        <span className="grid h-10 w-36 place-content-center rounded-lg bg-transparent text-xs text-gray-600 mt-24">
          <a className="block text-black" href="/dashboard">
            <span className="sr-only">PrepNexa</span>
            <img
              className="w-40 h-auto object-contain"
              src="/image/prep2.png"
              alt="PrepNexis Logo"
            />
          </a>
        </span>

        <ul className="mt-6 space-y-1">
          <li>
            <a
              href="/dashboard"
              className="block rounded-lg bg-gray-100 px-4 py-2 text-sm font-medium text-gray-700"
            >
              Dashboard
            </a>
          </li>

          <li>
            <a
              href="/practice"
              className="block rounded-lg bg-gray-100 px-4 py-2 text-sm font-medium text-gray-500"
            >
              Practice Material
            </a>
          </li>

          {/* <li>
                <a
                  href=""
                  className="block rounded-lg bg-gray-100 px-4 py-2 text-sm font-medium text-gray-500"
                >
                  Weekly Prediction
                </a>
              </li> */}

          {/* <li>
                <a
                  href=""
                  className="block rounded-lg bg-gray-100 px-4 py-2 text-sm font-medium text-gray-500"
                >
                  Templates
                </a>
              </li> */}

          {/* <li>
                <a
                  href=""
                  className="block rounded-lg bg-gray-100 px-4 py-2 text-sm font-medium text-gray-500"
                >
                  Prediction Files
                </a>
              </li> */}

          <li>
            <a
              href="/mockpage"
              className="block rounded-lg bg-gray-100 px-4 py-2 text-sm font-medium text-gray-500"
            >
              Mock Test
            </a>
          </li>

          {/* <li>
                <a
                  href=""
                  className="block rounded-lg bg-gray-100 px-4 py-2 text-sm font-medium text-gray-500"
                >
                  Live Sessions
                </a>
              </li> */}

          <li>
            <a
              href="/billing"
              className="block rounded-lg px-4 py-2 text-sm font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-700"
            >
              Billing
            </a>
          </li>

          <li>
            <details className="group mb-32 [&_summary::-webkit-details-marker]:hidden">
              <summary className="flex cursor-pointer items-center justify-between rounded-lg px-4 py-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700">
                <span className="text-sm font-medium"> Account </span>

                <span className="shrink-0 transition duration-300 group-open:-rotate-180">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
              </summary>

              <ul className="mt-2 space-y-1 px-4">
                {/* <li>
                      <a
                        href="/account"
                        className="block rounded-lg px-4 py-2 text-sm font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-700"
                      >
                        Details
                      </a>
                    </li> */}

                {/* <li>
                      <a
                        href=""
                        className="block rounded-lg px-4 py-2 text-sm font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-700"
                      >
                        Security
                      </a>
                    </li> */}
              </ul>
            </details>
          </li>
        </ul>
      </div>

      {/* Logout Button (Sticks to Bottom) */}
      <div className="absolute inset-x-0 bottom-0 border-t border-gray-100 bg-white p-2">
        <form>
          <button
            onClick={handleLogout}
            type="button"
            className="group relative flex items-center justify-center w-full rounded-lg px-2 py-1.5 text-sm text-gray-500 hover:bg-gray-50 hover:text-gray-700"
          >
            <p className="text-sm pr-2">
              <strong className="block font-medium">Logout</strong>
            </p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 opacity-75"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
              />
            </svg>
          </button>
        </form>
      </div>
    </div>
  );
}
